export default Object.freeze({
  ONE_HUNDRED_G: 'ONE_HUNDRED_G',
  ONE_HUNDRED_ML: 'ONE_HUNDRED_ML',
  TEN_G: 'TEN_G',
  TEN_ML: 'TEN_ML',
  ONE_G: 'ONE_G',
  ONE_M: 'ONE_M',
  ONE_ML: 'ONE_ML',
  SEVENFIVE_CL: 'SEVENFIVE_CL',
  ONE_KG: 'ONE_KG',
  ONE_LITRE: 'ONE_LITRE',
  EACH: 'EACH',
  OTHER: 'OTHER',
});
